export enum ProductType {
    Club = 'club',
    Donation = 'donation',
    Payment = 'payment',
}
